import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { fetchAllReferenceData } from '../../../../../../utils/employee/fetchAllReferenceData';
import { buildTemplateWorksheet } from '../../../../../../utils/employee/buildWorksheet';

export const generateDownloadAddressTemplate = async () => {
  const workbook = new ExcelJS.Workbook();
  
  // ADDED: Fetch refs and dynamic config
  const refs = await fetchAllReferenceData(); 

  const addressSection = {
    // Merge root and address into one combined section for this sheet
    // Both have apiKey: null so they are flat on the employee object
    apiKey: null,
    feature: null,
    fields: [
      {
        key: "region",
        label: "Region",
        type: "string",
        width: 30,
        sampleValue: "<CALABARZON>",
      },
      {
        key: "province",
        label: "Province",
        type: "string",
        width: 30,
        sampleValue: "<Laguna>",
      },
      {
        key: "city",
        label: "City",
        type: "string",
        width: 30,
        sampleValue: "<San Pablo>",
      },
      {
        key: "barangay",
        label: "Barangay",
        type: "string",
        width: 30,
        sampleValue: "<San Roque>",
      },
      {
        key: "street",
        label: "Street",
        type: "string",
        width: 30,
        sampleValue: "<Molave St.>",
      },
      {
        key: "blkLot",
        label: "BlkLot",
        type: "string",
        width: 30,
        sampleValue: "<143>",
      },
      {
        key: "postalCode",
        label: "PostalCode",
        type: "string",
        width: 30,
        sampleValue: "<0000>",
      },
    ],
  };

  // MODIFIED: Swapped hardcoded logic for buildTemplateWorksheet
  await buildTemplateWorksheet(
    workbook,
    "EmployeeAddress",
    addressSection,
    refs,
    {
      prependFields: [
        { key: "employeeId", label: "EmployeeId", width: 25, sampleValue: "<EMP1234>" },
        { key: "employeeName", label: "EmployeeName", width: 30, sampleValue: "<DELA CRUZ, JUAN>" },
      ],
    }
  );

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  saveAs(blob, 'Employee_Address_Template.xlsx');
};